const HOST_ICONS = [
  { match: /instagram\.com/i, icon: 'instagram' },
  { match: /facebook\.com|fb\.com/i, icon: 'facebook' },
  { match: /twitter\.com|x\.com/i, icon: 'twitter' },
  { match: /linkedin\.com/i, icon: 'linkedin' },
  { match: /youtube\.com|youtu\.be/i, icon: 'play' },
  { match: /mailto:|@[^\s]+\./i, icon: 'email' },
  { match: /tel:/i, icon: 'phone' },
]

export function getLinkIcon(url = '') {
  const value = String(url || '')
  for (const entry of HOST_ICONS) {
    if (entry.match.test(value)) return entry.icon
  }
  return 'website'
}
